import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Enable logs to be sent to Sentry
  enableLogs: true,
  integrations: [
    // Auto-capture breadcrumbs: what user did before an error
    Sentry.breadcrumbsIntegration({
      console: false, // Don't capture console.log as breadcrumbs (noisy)
      dom: true,      // Capture clicks, inputs
      fetch: true,    // Capture API requests
      xhr: true,      // Capture XHR requests
    }),
    // Performance monitoring
    Sentry.browserTracingIntegration(),
    // Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],

  // Performance: sample 100% of transactions (adjust in prod if too expensive)
  tracesSampleRate: 1.0,
  // Track performance for API calls to your backend
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/.*api\.hourglass\.law/,
    /^https:\/\/hourglassapi\./,
  ],
});
